<template>
  <div class="flex items-center">
    <fa
      :icon="['fas', 'star']"
      class="text-bubblegum-500 mb-0.5"
    />
    <span class="ml-1">
      {{ rating }}
    </span>
    <span>・</span>
    <span
      class="tracking-tight lowercase"
      :class="{ 'underline font-medium': isButton }"
    >
      {{ partner.rating_count }}
      {{ $tc('quote.review', partner.rating_count) }}
    </span>
  </div>
</template>

<script>
import { formatRating } from '@/helpers/format';

export default {
  name: 'VetsterReviewsCount',

  props: {
    partner: {
      type: Object,
      required: true,
    },
    isButton: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rating() {
      return formatRating(this.partner);
    },
  },
};
</script>
